import ToggleButton from "../fields/ToggleButton";

interface StepTravauxProps {
  value: string;
  onChange: (value: string) => void;
}

const OPTIONS = ["Neuf", "Rénovation"];

export default function StepTravaux({ value, onChange }: StepTravauxProps) {
  return (
    <fieldset style={{ border: "none" }}>
      <legend
        style={{
          fontSize: 16,
          fontWeight: 500,
          marginBottom: 12,
          display: "block",
          width: "100%",
        }}
      >
        Quel est le type de vos travaux ?
      </legend>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 12,
        }}
      >
        {OPTIONS.map((opt) => (
          <ToggleButton
            key={opt}
            label={opt}
            value={opt}
            active={value === opt}
            onClick={onChange}
            type="radio"
          />
        ))}
      </div>
    </fieldset>
  );
}
